/**/
'use strict';

require('./app/product');
require('./app/burger');